import "./Login.style.scss";
import { useRouter } from "src/hooks/useRouter";
import ProductCard from "./ProductCard";
import { UseFormReturn } from "react-hook-form";
import { LoginFormData } from "./Login.schema";
import FormInput from "components/Common/Form/Input/FormInput";
import { useModal } from "src/hooks/useModal";
import Checkbox from "components/Common/Form/Checkbox";
import { FormContainer } from "components/Common/Form/Input/FormContainer";
import { SubmitBtn } from "components/Common/Form/SubmitBtn";
import { useTranslation } from "react-i18next";
interface ILoginUIProps {
  // 폼 데이터
  userId: string;
  password: string;
  isIdSave: boolean;
  // 상태
  isShowFindPassword: boolean;
  loginPossible: boolean;
  invalidUser: boolean;
  // 폼 관련
  loginForm: UseFormReturn<LoginFormData>;
  onLoginSubmit: (data: LoginFormData) => void;
  // 핸들러
  handleChangeIdSave: () => void;
  goBackLogin: () => void;
  goFindPassword: () => void;
}

const LoginUI = (props: ILoginUIProps) => {
  const {
    // 상태
    loginPossible,
    // 폼 관련
    loginForm,
    onLoginSubmit,
  } = props;
  const { goJoin } = useRouter();
  const { setPasswordInitModal } = useModal();
  const { t } = useTranslation();
  const tab = "common";
  return (
    <div className="loginBody">
      <div className="loginContainer">
        {/* 좌측 제품 정보 카드 */}
        <ProductCard />

        {/* 우측 로그인 폼 */}
        <div className="loginCard">
          <div className="tabContainer">
            <div className="tab" onClick={goJoin}>
              <span className="tabText">{t("logIn.signUp.title")}</span>
            </div>
            <div className="tab active">
              <span className="tabText">{t("logIn.goToLoginBtn")}</span>
            </div>
          </div>

          <FormContainer onSubmit={loginForm.handleSubmit(onLoginSubmit)}>
            <FormInput
              label={t("navBar.myAccount.email")}
              name="userId"
              type="email"
              register={loginForm.register}
              errors={loginForm.formState.errors}
              placeholder={t("logIn.enterUserEmail")}
            ></FormInput>

            <FormInput
              label={t("logIn.password")}
              name="password"
              type="password"
              register={loginForm.register}
              errors={loginForm.formState.errors}
              placeholder={t("logIn.enterPassword")}
            ></FormInput>
            <div
              className="flex justify-space-between w-100 items-center"
              style={{ marginTop: "10px", marginBottom: "20px" }}
            >
              <Checkbox
                name="isIdSave"
                register={loginForm.register}
                errors={loginForm.formState.errors}
              >
                <label htmlFor="isIdSave" className="checkboxLabel">
                  {t("logIn.rememberId")}
                </label>
              </Checkbox>
              <div className="forgotPassword">
                <a
                  onClick={() => setPasswordInitModal(true)}
                  className="cursor-pointer"
                >
                  {t("logIn.resetPassowrd.title")}
                </a>
              </div>
            </div>
            <SubmitBtn
              disabled={!loginPossible || loginForm.formState.isSubmitting}
              text={t("logIn.goToLoginBtn")}
            />
            {/* 로그인 링크 */}
            <div className="formDescription">
              <span className="formDescriptionText">
                {t("logIn.checkMember")}
              </span>
              <span className="formDescriptionLink">
                <a onClick={goJoin}>{t("logIn.goToSignUp")}</a>
              </span>
            </div>
          </FormContainer>
        </div>
      </div>
    </div>
  );
};

export default LoginUI;
